import comp from "./GenericCheckBox";
export default comp;
